import Sidebar from '../MemberSidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { Outlet, useNavigate } from 'react-router-dom';

const MemberDashboard = () => {
  const navigate = useNavigate();
  return (
    <div className="app-container d-flex">
          <Sidebar className="sidebar" />
          <div className="dashboard-wrapper flex-grow-1">
            <div className="mobile-message">
              <div>
                <p>Open Your Dashboard on Desktop</p>
                <button className="btn btn-primary go-home-btn" onClick={() => navigate('/')}>
                  Go Home
                </button>
              </div>
            </div>
            <div className="desktop-content">
              <Outlet />
            </div>
          </div>
        </div>
  );
};

export default MemberDashboard;